export default __webpack_public_path__ + "static/media/learn-placeholder-1.e307ccee.png";